import {
  ListFrameworkSectionsRequest,
  ListFrameworkSectionsResponse,
} from '@trustero/trustero-api-web/lib/model/framework_pb'
import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'

/**
 * Fetches the section headers for a compliance framework. Each section
 * carries a model_id, name, and details.
 */
export const useFrameworkSections = (
  complianceFrameworkModelId: string,
  enabled = true,
): GrpcResponse<ListFrameworkSectionsResponse> => {
  const request =
    new ListFrameworkSectionsRequest().setComplianceFrameworkModelId(
      complianceFrameworkModelId,
    )
  const { response } = useSwrImmutableGrpc(
    ModelPromiseClient.prototype.listFrameworkSections,
    request,
    enabled && !!complianceFrameworkModelId,
  )
  return NewGrpcResponse(response)
}
